import React from 'react';

function CompanyIcon({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 18 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4.12123V9.29123H16C17.1 9.29123 18 10.1912 18 11.2912V17.2912C18 18.3912 17.1 19.2912 16 19.2912H2C0.9 19.2912 0 18.3912 0 17.2912V7.29123C0 6.19123 0.9 5.29123 2 5.29123H6V4.12123C6 3.59123 6.21 3.08123 6.59 2.70123L8.29 1.00123C8.47683 0.813973 8.73048 0.70874 8.995 0.70874C9.25952 0.70874 9.51317 0.813973 9.7 1.00123L11.41 2.71123C11.79 3.08123 12 3.59123 12 4.12123ZM2 17.2912H4V15.2912H2V17.2912ZM4 13.2912H2V11.2912H4V13.2912ZM2 9.29123H4V7.29123H2V9.29123ZM10 17.2912H8V15.2912H10V17.2912ZM8 13.2912H10V11.2912H8V13.2912ZM10 9.29123H8V7.29123H10V9.29123ZM8 5.29123H10V3.29123H8V5.29123ZM16 17.2912H14V15.2912H16V17.2912ZM14 13.2912H16V11.2912H14V13.2912Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default CompanyIcon;
